import { render } from "./LegoStepReceipt.vue?vue&type=template&id=8638fad4"
import script from "./LegoStepReceipt.vue?vue&type=script&lang=js"
export * from "./LegoStepReceipt.vue?vue&type=script&lang=js"
script.render = render

export default script